import { ComplaintService } from './../_services/complaint.service';
// import { selectComplaintsInitWaitingMessage } from './../_selectors/product.selectors';
// RxJS
import { Observable, of } from "rxjs";
import 'rxjs/add/observable/of';
import { catchError, delay, distinctUntilChanged, finalize } from 'rxjs/operators';
// CRUD
import { QueryResultsModel, BaseDataSource } from '../../_base/crud';
// State
import { Store, select } from '@ngrx/store';
import { AppState } from '../../reducers';
// Service

export class ComplainsDataSource extends BaseDataSource {
  constructor(private complainService:ComplaintService) {
    super();
    // this.loading$ = this.store.pipe(
    //   select(selectComplaintsPageLoading)
    // );

    // this.isPreloadTextViewed$ = this.store.pipe(
    //   select(selectComplaintsShowInitWaitingMessage)
    // );

    // this.store.pipe(
    //   select(selectComplaintsInStore)
    // ).subscribe((response: QueryResultsModel) => {
    //   this.paginatorTotalSubject.next(response.totalCount);
    //   this.entitySubject.next(response.items);
    // });
  }
  loadPageRequesed(page) {
    this.loading$ = Observable.of(true);
    this.isPreloadTextViewed$ = Observable.of(true);
    this.complainService.findComplaints(page).pipe(
      catchError(() => of([])),
      finalize(() => this.isPreloadTextViewed$ = this.loading$ = Observable.of(false),)
    ).subscribe(response => {
      this.loading$ = Observable.of(false);
      this.isPreloadTextViewed$ = Observable.of(false);
      const data = response['data'];
      this.paginatorTotalSubject.next(data.totalElements);
      this.entitySubject.next(data['content']);
    })
  }
}
